/**
 *
 * @param {string} tagId  当前宝宝月龄id  1是备孕，2是怀孕，3是0-6月，4是6-12月，5是12-36月，6是36月以上
 * @returns arr：根据不同的月龄状态返回的工具数组
 *
 * 备孕工具：扫码积分、产品溯源、备孕宝典、能不能吃、助眠音乐、奶粉百科、星牧场，专家问答、云相册
 * 孕期：孕期宝典15、能不能吃9、胎教音乐16、产检提醒17、孕期相册18、扫码积分6、产品溯源7、星牧场
 * 0-6月龄：育儿宝典1、生长曲线3、喂养记录21、哄睡儿歌22、扫码积分、产品溯源、疫苗时间表、能不能吃
 * 6-12月龄：育儿宝典、生长曲线、能不能吃、宝宝相册、哄睡儿歌、扫码积分、产品溯源、疫苗时间表
 * 12-36月龄：育儿宝典、宝宝食谱2、生长曲线、宝宝相册、儿歌故事、扫码积分、产品溯源、疫苗时间表
 * 36月龄以上：育儿宝典、宝宝食谱、生长曲线、儿歌故事、扫码积分、产品溯源、疫苗时间表、家庭问诊
 *
 */

export function getToolSort(tagId) {
    switch (tagId) {
        case "1":
            return [6, 7, 36, 9, 11, 32, 30, 13, 14];
        case "2":
            return [6, 7, 36, 9, 16, 17, 18, 32, 30];
        case "3":
            return [6, 7, 36, 3, 32, 21, 35, 8, 34];
        case "4":
            return [6, 7, 19, 3, 9, 35, 33, 36, 8, 32];
        case "5":
            return [6, 7, 19, 35, 3, 33, 36, 4, 32, 8];
        case "6":
            return [6, 36, 33, 19, 35, 3, 5, 4, 32, 8];
        default:
            return []
    }
}